import { IonIcon, IonImg } from '@ionic/react';
import { cloudOffline, playCircle } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { SelectNetworkConnected } from '../../store/UserSlice';
import './PostVideos.scss';

export interface IPostVideosProps {
    postText?: string;
    delay?: number;
    cssClass?: string;
    thumbNailOnly?: boolean;
    showEmbed?: boolean;
    postId?: string;
    scrollToBottom?: Function;
}

const PostVideos: React.FC<IPostVideosProps> = (props) => {
    const [youTubeVideoCodes, setYouTubeVideoCodes] = useState<string[]>([]);
    const [showEmbed, setShowEmbed] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const delayTimer = useRef<any>(0);
    const networkConnected = useSelector(SelectNetworkConnected);

    useEffect(() => {
        if(props.postText) {
            delayTimer.current = setTimeout(() => {
                const youTubeRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu\.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
                const postWords = props.postText ? props.postText.replace( /\n/g, " " ).split(' ') : [];
                const youTubeCodes: string[] = [];
                postWords.forEach(word => {
                    const youTubeMatch = word.match(youTubeRegex);
                    if(youTubeMatch && youTubeMatch[6].length > 10) {
                        youTubeCodes.push(youTubeMatch[6] );
                    }
                })
                setYouTubeVideoCodes(youTubeCodes);
                setShowEmbed(false);
                clearTimeout(delayTimer.current);

            }, props.delay ? props.delay : 0);
        }

        return () => {
            clearTimeout(delayTimer.current);
        }
    }, [props.postText]);

    useEffect(() => {
      if(networkConnected && !imageLoaded) {
        setImageLoaded(true);
      }
    }, [networkConnected]);

    useEffect(() => {
        if(youTubeVideoCodes.length && props.scrollToBottom) {
            props.scrollToBottom();
        }
      }, [youTubeVideoCodes]);

    const renderYouTubeVideo = (videoCode: string) => {
        return <div className="post-video-container" key={`post-youTube-${videoCode}-${Date.now()}`}>
            <div className='post-video-youTube'>
                <iframe width='560' height='315' title={`YouTube-${videoCode}`}
                    src={`https://www.youtube.com/embed/${videoCode}?rel=0&modestbranding=1&showinfo=0`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
        </div>
    }

    const renderYouTubeThumbnail = (videoCode: string) => {
        return <div className="videos" key={`post-thumbnail-${videoCode}-${props.postId}-${Date.now()}`}>
        <div className="video-wrap" onClick={() => setShowEmbed(!props.thumbNailOnly && networkConnected ? true : false)}>
            <IonIcon  className="play-btn" icon={networkConnected ? playCircle : cloudOffline}></IonIcon>
            <IonImg key={`post-thumbnail-${videoCode}-${props.postId}`} 
                src={`https://i.ytimg.com/vi/${videoCode}/mqdefault.jpg`} 
                className="placeholder"
                onIonError={()=>setImageLoaded(false)}
                onIonImgDidLoad={()=>setImageLoaded(true)}></IonImg>
        </div>
      </div>
    }

    
    return imageLoaded ? <div className={youTubeVideoCodes.length ? `post-videos-root ${props.cssClass}` : "hidden"} >
        {
            youTubeVideoCodes.length ? youTubeVideoCodes.map(videoCode => {
                return showEmbed || (props.showEmbed && networkConnected) ? renderYouTubeVideo(videoCode) : renderYouTubeThumbnail(videoCode)
            }
        ): ''}
    </div> : <div className="hidden"></div>
};

export default PostVideos;